<template>
  <div class="order-notice reject-notice">
    <div class="status-banner reject">
      <div class="banner-title">{{ payload.title || '商务已拒绝该订舱申请' }}</div>
      <div class="banner-sub">{{ payload.titleInfo || '' }}</div>
    </div>

    <div class="section">
      <div class="section-label">拒绝原因</div>
      <div class="reason-box">{{ payload.content || '—' }}</div>
    </div>
    <div class="meta-row">
      <div class="meta-item">
        <div class="meta-label">订单号</div>
        <div class="meta-value">{{ payload.orderNo || '—' }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">原船期</div>
        <div class="meta-value">{{ payload.scheduleInfo || '—' }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">起始港</div>
        <div class="meta-value">{{ displayPolName }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">目的港</div>
        <div class="meta-value">{{ displayPodName }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">业务人</div>
        <div class="meta-value">{{ payload.businessName || '—' }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">下单时间</div>
        <div class="meta-value">{{ payload.createTime || '—' }}</div>
      </div>
    </div>

    <div class="notice-actions">
      <el-button @click="$emit('copy-order')">复制订单重下</el-button>
      <el-button type="primary" @click="$emit('read')">已读</el-button>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order.js'
import { parsePortNameLabel } from '@/utils/scheduleDisplay.js'

export default {
  name: 'OrderRejectNotice',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      displayPolName: '—',
      displayPodName: '—'
    }
  },
  watch: {
    payload: {
      immediate: true,
      handler(val) {
        this.syncPortDisplay(val)
      }
    }
  },
  methods: {
    async syncPortDisplay(payload) {
      if (!payload) {
        this.displayPolName = '—'
        this.displayPodName = '—'
        return
      }
      let polName = payload.polName || ''
      let podName = payload.podName || ''
      if ((!polName || !podName) && payload.orderId) {
        try {
          const res = await orderApi.queryRejectReason(payload.orderId)
          if (res.code === 200 && res.data) {
            const data = res.data
            if (!polName) {
              polName = parsePortNameLabel(data.modifiedPolName || data.polName || data.modifiedPol || data.pol) || ''
            }
            if (!podName) {
              podName = parsePortNameLabel(data.podName || data.pod) || ''
            }
          }
        } catch (e) {
          // ignore
        }
      }
      this.displayPolName = polName || '—'
      this.displayPodName = podName || '—'
    }
  }
}
</script>

<style scoped>
.order-notice {
  padding: 4px 4px 0;
}
.status-banner {
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
}
.status-banner.reject {
  background: #fff1f0;
  border: 1px solid #ffccc7;
}
.banner-title {
  font-size: 15px;
  font-weight: 700;
  color: #cf1322;
  margin-bottom: 6px;
  line-height: 1.4;
}
.banner-sub {
  font-size: 13px;
  color: #a8071a;
  line-height: 1.4;
  opacity: 0.85;
}
.section-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 8px;
}
.reason-box {
  min-height: 72px;
  padding: 12px 14px;
  border: 1px solid #e8ebf0;
  border-radius: 8px;
  background: #fafbfc;
  color: #1f2329;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.meta-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}
.meta-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 4px;
}
.meta-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  word-break: break-all;
}
.notice-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
</style>
